import '@/scss/pages/tests-tax.scss'

import header from '../layout/header'
import sliderTestsPdf from '../section/tests/shortcode-pdf'
import singleCTA from '../section/blog/single-cta'
import fullForm from '../section/home/full-form'
import { getTableOfContents } from '../common/table-of-contents'
import setFact from '../common/quiz'
import anchor from '../common/anchor'
import initStrip from '../section/blog/strip'
import { bannerCta, bannerWide } from '../common/banners'
import useFAQ from '@/js/section/pricing/faq'
import manageClassName from '../helpers/manage-class'

document.addEventListener('DOMContentLoaded', function () {
  header()
  sliderTestsPdf()
  singleCTA()
  fullForm()
  useFAQ()
  getTableOfContents()
  setFact()
  anchor()
  initStrip()
  bannerWide()
  bannerCta()
  manageClassName('iframe', 'iframe-formatting', 'add')
})
